export default "__VITE_ASSET__DeZ7t6Mc__"